module.exports = __webpack_public_path__ + "assets/img/ali_scan.bd258bee.png";